import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * API URL Interceptor
 *
 * Prepends the base API URL from environment configuration to all HTTP requests.
 * Only applies to relative URLs (not starting with http:// or https://).
 * Handles trailing slashes to ensure proper URL concatenation.
 *
 * Execution order: First (runs before other interceptors)
 */
export const apiUrlInterceptor: HttpInterceptorFn = (req, next) => {
    const basePath = environment.basePath;
    const apiVersion = environment.apiVersion;

    // Check if the request URL is relative (doesn't start with http:// or https://)
    const isRelativeUrl = !req.url.startsWith('http://') && !req.url.startsWith('https://');

    if (isRelativeUrl && basePath) {
        // Remove trailing slash from base URL and leading slash from request URL
        const baseUrl = basePath.replace(/\/$/, '');
        const requestUrl = req.url.startsWith('/') ? req.url : `/${req.url}`;

        // Construct the full URL with API version
        const fullUrl = `${baseUrl}/${apiVersion}${requestUrl}`;

        // Clone the request with the new URL
        const modifiedReq = req.clone({
            url: fullUrl
        });

        return next(modifiedReq);
    }

    // For absolute URLs, pass the request through unchanged
    return next(req);
};;
